export const MAXPAY_SYNC_CHANNEL = "phoenix-maxpay-sync";
export const MAXPAY_SYNC_STORAGE_KEY = "phoenix:maxpay-sync";
export const MAXPAY_UPDATED_EVENT = "phoenix:maxpay-updated";
